/**
 * Pads a given input with leading zeroes until it reaches the desired length.
 * @param input a string
 * @param targetLength desired length of output
 */
export const padZeroes = (input: string, targetLength: number): string => {
    let result = input;
    let difference = targetLength - input.length;

    while (difference > 0) {
        result = `0${result}`;
        difference -= 1;
    }

    return result;
};
